import { ValidationItem } from '@app/queryTyping';

export const handleServerErrors = (err: Pick<ValidationItem, 'messages'>[] | null | undefined): string => {
  const validationErrors = err?.map((e) => e?.messages?.flat().join(', '));
  if (validationErrors?.length) {
    return validationErrors?.join(', ');
  }
  return '';
};
